import { FC } from 'react'

import InteractiveGameDisplay from '@/components/InteractiveGameDisplay'

const CheckoutImagesDesktop: FC<{
    activeImageIndex: number
}> = ({ activeImageIndex }) => {
    return (
        <>
            {[0, 1, 2].map((i) => {
                const imagePath = `/images/interactive-checkout/interactive-checkout-mobile-${i}.png`
                const isActive = i === activeImageIndex
                return (
                    <InteractiveGameDisplay
                        key={`interactive-map-bg-${i}`}
                        backgroundImageProperty={imagePath}
                        isActive={isActive}
                    />
                )
            })}
        </>
    )
}

export default CheckoutImagesDesktop
